import { Helmet } from "react-helmet";
import Layout from "../../components/Layout";
import { useCallback, useEffect, useState } from "react";
import { useIntersecting } from "../../hooks/useIntersecting";
import BaseSection from "../../components/sections/BaseSection";
import ProjectCard from "../../components/sections/projectSection/ProjectCard";
import { projects } from '../../constants/projects'
import styled from "styled-components";
import { media } from "../../constants/styles";

interface Props { }
const Project: React.FC<Props> = () => {
  const { ref, isIntersecting } = useIntersecting();
  const [_, setInteracted] = useState<boolean>(false);

  const renderContents = useCallback(() => {
    return projects.map((project, index) => <ProjectCard key={index} project={project} size="small" />)
  }, [])

  useEffect(() => {
    if (isIntersecting) setInteracted(true);
  }, [isIntersecting]);

  return (
    <Layout>
      {/* Helmet */}
      <Helmet>
        <title>Slogup - Projects</title>
      </Helmet>

      {/* Body */}
      <BaseSection ref={ref} fullHeight style={{ backgroundColor: '#111' }}>
        <Container>
          <GridWrapper>
            {renderContents()}
          </GridWrapper>
        </Container>
      </BaseSection>
    </Layout>
  )
};

export default Project;

const Container = styled.div`
  width: 100%;
  padding: 108px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 1200px;

  ${media.TABLET} {
    width: 100%;
    padding: 108px 48px;
    max-width: auto;
  }
  ${media.MOBILE} {
    width: 100%;
    padding: 92px 24px;
    max-width: auto;
  }
`

const GridWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 100px 40px;

  ${media.TABLET} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${media.MOBILE} {
    grid-template-columns: 1fr;
  }
`